import { render, staticRenderFns } from "./SearchResultsTabs.vue?vue&type=template&id=1a2bcd8e&scoped=true&lang=pug&"
import script from "./SearchResultsTabs.vue?vue&type=script&lang=js&"
export * from "./SearchResultsTabs.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsTabs.vue?vue&type=style&index=0&id=1a2bcd8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2bcd8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2bcd8e')) {
      api.createRecord('1a2bcd8e', component.options)
    } else {
      api.reload('1a2bcd8e', component.options)
    }
    module.hot.accept("./SearchResultsTabs.vue?vue&type=template&id=1a2bcd8e&scoped=true&lang=pug&", function () {
      api.rerender('1a2bcd8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/search/SearchResultsTabs.vue"
export default component.exports